export type StandaloneDisplayInput = {
  displayModeFullscreen?: boolean;
  displayModeMinimalUi?: boolean;
  displayModeStandalone: boolean;
  navigatorStandalone?: boolean;
};

export function detectStandaloneDisplay({
  displayModeFullscreen = false,
  displayModeMinimalUi = false,
  displayModeStandalone,
  navigatorStandalone,
}: StandaloneDisplayInput): boolean {
  return (
    displayModeStandalone ||
    displayModeFullscreen ||
    displayModeMinimalUi ||
    navigatorStandalone === true
  );
}

function readNavigatorStandalone(navigator: Navigator): boolean | undefined {
  const standalone = Reflect.get(navigator, 'standalone');
  if (typeof standalone === 'boolean') {
    return standalone;
  }

  return undefined;
}

export function readInstalledDisplayMode(): boolean {
  if (typeof window === 'undefined') return false;

  return detectStandaloneDisplay({
    displayModeFullscreen: window.matchMedia('(display-mode: fullscreen)')
      .matches,
    displayModeMinimalUi: window.matchMedia('(display-mode: minimal-ui)')
      .matches,
    displayModeStandalone: window.matchMedia('(display-mode: standalone)')
      .matches,
    navigatorStandalone: readNavigatorStandalone(window.navigator),
  });
}
